import {
  SiAndroid,
  SiAngular,
  SiApple,
  SiC,
  SiConfluence,
  SiCplusplus,
  SiCypress,
  SiDart,
  SiDjango,
  SiDocker,
  SiDotnet,
  SiElasticsearch,
  SiFastapi,
  SiFigma,
  SiFlask,
  SiFlutter,
  SiGin,
  SiGo,
  SiGoogleanalytics,
  SiJavascript,
  SiJenkins,
  SiJetpackcompose,
  SiJira,
  SiJupyter,
  SiKotlin,
  SiKubernetes,
  SiLaravel,
  SiMaterialdesign,
  SiMiro,
  SiNestjs,
  SiNodedotjs,
  SiNotion,
  SiOpenjdk,
  SiPhp,
  SiPostgresql,
  SiProducthunt,
  SiPython,
  SiReact,
  SiRedis,
  SiSelenium,
  SiSpringboot,
  SiSwift,
  SiSymfony,
  SiTensorflow,
  SiTestinglibrary,
  SiTypescript,
  SiUnity,
  SiVuedotjs,
  SiWordpress,
  SiXcode,
} from '@icons-pack/react-simple-icons'

interface TechIcon {
  component: React.ComponentType<{ size?: number, className?: string, style?: React.CSSProperties }>
  name: string
  color?: string
}

interface TechSpec {
  id: string
  title: string
  description: string
  category: string
  questionCount: number
  interviewCount?: number
  lastUpdated?: string
  href: string
  imagePath: string
  techIcons: TechIcon[]
  enabled: boolean
}

interface TechSpecGroup {
  id: string
  title: string
  description: string
  specializations: TechSpec[]
  enabled: boolean
}

export const techSpecsGroups: TechSpecGroup[] = [
  {
    id: 'programming',
    title: 'Программирование',
    description: 'Разработка программного обеспечения: frontend, backend, mobile и game development с использованием современных языков и фреймворков',
    enabled: true,
    specializations: [
      {
        id: 'data-engineer',
        title: 'Data Engineer',
        description: 'Проектирование и построение data pipeline, ETL/ELT процессы, работа с большими данными, оптимизация хранилищ',
        category: 'Программирование',
        questionCount: 67,
        interviewCount: 8,
        lastUpdated: '1 неделя назад',
        href: '/questions/data-engineer',
        imagePath: '/specializations/turned-on-monitoring-screen.jpg',
        techIcons: [
          { component: SiPython, name: 'Python' },
          { component: SiElasticsearch, name: 'Elasticsearch' },
          { component: SiPostgresql, name: 'PostgreSQL' },
          { component: SiRedis, name: 'Redis' },
        ],
        enabled: false,
      },
      {
        id: 'ios-developer',
        title: 'iOS Developer',
        description: 'Разработка нативных приложений для iOS и iPadOS с использованием Swift, SwiftUI, UIKit и современных Apple фреймворков',
        category: 'Программирование',
        questionCount: 89,
        interviewCount: 14,
        lastUpdated: '5 дней назад',
        href: '/questions/ios-developer',
        imagePath: '/specializations/a-close-up-of-a-cell-phone-on-a-desk.jpg',
        techIcons: [
          { component: SiSwift, name: 'Swift' },
          { component: SiXcode, name: 'Xcode' },
          { component: SiApple, name: 'Apple' },
        ],
        enabled: false,
      },
      {
        id: 'devops',
        title: 'DevOps',
        description: 'Автоматизация развертывания и мониторинга, построение CI/CD пайплайнов, контейнеризация, оркестрация, IaC',
        category: 'Программирование',
        questionCount: 92,
        interviewCount: 18,
        lastUpdated: '3 дня назад',
        href: '/questions/devops',
        imagePath: '/specializations/a-group-of-blue-boxes.jpg',
        techIcons: [
          { component: SiDocker, name: 'Docker' },
          { component: SiKubernetes, name: 'Kubernetes' },
          { component: SiJenkins, name: 'Jenkins' },
        ],
        enabled: false,
      },
      {
        id: 'flutter-developer',
        title: 'Flutter Developer',
        description: 'Кроссплатформенная разработка мобильных приложений на Dart и Flutter для iOS, Android и веб',
        category: 'Программирование',
        questionCount: 76,
        interviewCount: 11,
        lastUpdated: '1 неделя назад',
        href: '/questions/flutter-developer',
        imagePath: '/specializations/flutter-logo-and-mascot.jpeg',
        techIcons: [
          { component: SiFlutter, name: 'Flutter', color: '#02569B' },
          { component: SiDart, name: 'Dart', color: '#0175C2' },
          { component: SiMaterialdesign, name: 'Material Design', color: '#757575' },
        ],
        enabled: false,
      },
      {
        id: 'frontend-developer',
        title: 'Frontend Developer',
        description: 'Разработка пользовательских интерфейсов с использованием современных JS/TS фреймворков, HTML, CSS и инструментов сборки',
        category: 'Программирование',
        questionCount: 954,
        interviewCount: 197,
        lastUpdated: '2 недели назад',
        href: '/questions/frontend-developer',
        imagePath: '/specializations/a-close-up-of-a-computer-screen-with-a-bunch-of-text-on-it.jpg',
        techIcons: [
          { component: SiJavascript, name: 'JavaScript', color: '#F7DF1E' },
          { component: SiTypescript, name: 'TypeScript', color: '#3178C6' },
          { component: SiReact, name: 'React', color: '#61DAFB' },
          { component: SiVuedotjs, name: 'Vue.js', color: '#4FC08D' },
          { component: SiAngular, name: 'Angular', color: '#DD0031' },
        ],
        enabled: true,
      },
      {
        id: 'android-developer',
        title: 'Android Developer',
        description: 'Разработка нативных Android приложений с использованием Kotlin, Jetpack Compose, Material Design и Android SDK',
        category: 'Программирование',
        questionCount: 94,
        interviewCount: 16,
        lastUpdated: '4 дня назад',
        href: '/questions/android-developer',
        imagePath: '/specializations/a-group-of-green-androids-sitting-next-to-each-other.jpg',
        techIcons: [
          { component: SiKotlin, name: 'Kotlin' },
          { component: SiOpenjdk, name: 'Java' },
          { component: SiAndroid, name: 'Android' },
          { component: SiJetpackcompose, name: 'Jetpack Compose' },
        ],
        enabled: false,
      },
      {
        id: 'unity-developer',
        title: 'Unity Developer',
        description: 'Разработка игр и интерактивных 3D приложений на Unity Engine с использованием C# и современных игровых паттернов',
        category: 'Программирование',
        questionCount: 58,
        interviewCount: 7,
        lastUpdated: '2 недели назад',
        href: '/questions/unity-developer',
        imagePath: '/specializations/unity-logo.png',
        techIcons: [
          { component: SiUnity, name: 'Unity' },
          { component: SiDotnet, name: 'C#/.NET' },
        ],
        enabled: false,
      },
      {
        id: '1c-developer',
        title: '1С Developer',
        description: 'Разработка и настройка конфигураций 1С:Предприятие, автоматизация бизнес-процессов, интеграция с внешними системами',
        category: 'Программирование',
        questionCount: 45,
        interviewCount: 5,
        lastUpdated: '3 недели назад',
        href: '/questions/1c-developer',
        imagePath: '/specializations/1c-logo.jpg',
        techIcons: [
          { component: SiPostgresql, name: 'PostgreSQL' },
        ],
        enabled: false,
      },
      {
        id: 'python-backend',
        title: 'Python Backend',
        description: 'Серверная разработка на Python с использованием Django, FastAPI, Flask, проектирование REST API и работа с БД',
        category: 'Программирование',
        questionCount: 134,
        interviewCount: 25,
        lastUpdated: '2 дня назад',
        href: '/questions/python-backend',
        imagePath: '/specializations/python-logo.jpg',
        techIcons: [
          { component: SiPython, name: 'Python' },
          { component: SiDjango, name: 'Django' },
          { component: SiFastapi, name: 'FastAPI' },
          { component: SiFlask, name: 'Flask' },
          { component: SiPostgresql, name: 'PostgreSQL' },
        ],
        enabled: true,
      },
      {
        id: 'java-backend',
        title: 'Java Backend',
        description: 'Enterprise разработка на Java с использованием Spring Boot, построение микросервисной архитектуры и интеграции',
        category: 'Программирование',
        questionCount: 156,
        interviewCount: 28,
        lastUpdated: '1 день назад',
        href: '/questions/java-backend',
        imagePath: '/specializations/java-logo.jpg',
        techIcons: [
          { component: SiOpenjdk, name: 'Java' },
          { component: SiSpringboot, name: 'Spring Boot' },
          { component: SiPostgresql, name: 'PostgreSQL' },
          { component: SiRedis, name: 'Redis' },
        ],
        enabled: false,
      },
      {
        id: 'golang-backend',
        title: 'Golang Backend',
        description: 'Высокопроизводительная серверная разработка на Go, построение микросервисов, concurrent programming',
        category: 'Программирование',
        questionCount: 78,
        interviewCount: 13,
        lastUpdated: '6 дней назад',
        href: '/questions/golang-backend',
        imagePath: '/specializations/gopher-mascot.jpg',
        techIcons: [
          { component: SiGo, name: 'Go' },
          { component: SiGin, name: 'Gin' },
          { component: SiPostgresql, name: 'PostgreSQL' },
          { component: SiRedis, name: 'Redis' },
        ],
        enabled: true,
      },
      {
        id: 'csharp-backend',
        title: 'C# Backend',
        description: 'Серверная разработка на .NET платформе с использованием ASP.NET Core, Entity Framework и современных паттернов',
        category: 'Программирование',
        questionCount: 89,
        interviewCount: 15,
        lastUpdated: '1 неделя назад',
        href: '/questions/csharp-backend',
        imagePath: '/specializations/csharp-logo.jpg',
        techIcons: [
          { component: SiDotnet, name: 'C#/.NET' },
          { component: SiPostgresql, name: 'PostgreSQL' },
        ],
        enabled: false,
      },
      {
        id: 'cpp-backend',
        title: 'C/C++ Backend',
        description: 'Низкоуровневая и высокопроизводительная разработка на C/C++, системное программирование, оптимизация алгоритмов',
        category: 'Программирование',
        questionCount: 67,
        interviewCount: 9,
        lastUpdated: '2 недели назад',
        href: '/questions/cpp-backend',
        imagePath: '/specializations/keith.jpeg',
        techIcons: [
          { component: SiCplusplus, name: 'C++' },
          { component: SiC, name: 'C' },
        ],
        enabled: false,
      },
      {
        id: 'php-backend',
        title: 'PHP Backend',
        description: 'Серверная разработка на PHP с использованием Laravel, Symfony, построение веб-приложений и CMS',
        category: 'Программирование',
        questionCount: 112,
        interviewCount: 19,
        lastUpdated: '4 дня назад',
        href: '/questions/php-backend',
        imagePath: '/specializations/blue-and-white-elephant-plush-toy-on-black-laptop-computer.jpg',
        techIcons: [
          { component: SiPhp, name: 'PHP' },
          { component: SiLaravel, name: 'Laravel' },
          { component: SiSymfony, name: 'Symfony' },
          { component: SiWordpress, name: 'WordPress' },
          { component: SiPostgresql, name: 'PostgreSQL' },
        ],
        enabled: true,
      },
      {
        id: 'nodejs-backend',
        title: 'Node.js Backend',
        description: 'Серверная JavaScript/TypeScript разработка на Node.js с использованием Express, NestJS и современных практик',
        category: 'Программирование',
        questionCount: 145,
        interviewCount: 23,
        lastUpdated: '3 дня назад',
        href: '/questions/nodejs-backend',
        imagePath: '/specializations/node-js-logo.webp',
        techIcons: [
          { component: SiNodedotjs, name: 'Node.js' },
          { component: SiNestjs, name: 'NestJS' },
          { component: SiTypescript, name: 'TypeScript' },
          { component: SiPostgresql, name: 'PostgreSQL' },
        ],
        enabled: true,
      },
    ],
  },
  {
    id: 'testing',
    title: 'Тестирование',
    description: 'Обеспечение качества ПО: функциональное и автоматизированное тестирование, QA процессы и контроль качества',
    enabled: true,
    specializations: [
      {
        id: 'qa-tester',
        title: 'QA Тестировщик',
        description: 'Ручное функциональное тестирование, составление тест-кейсов, баг-трекинг, регрессионное тестирование',
        category: 'Тестирование',
        questionCount: 89,
        interviewCount: 15,
        lastUpdated: '1 неделя назад',
        href: '/questions/qa-tester',
        imagePath: '/specializations/qa-testing-blocks.jpg',
        techIcons: [
          { component: SiTestinglibrary, name: 'Testing', color: '#E33332' },
          { component: SiJira, name: 'Jira' },
        ],
        enabled: false,
      },
      {
        id: 'qa-automation',
        title: 'QA Automation',
        description: 'Автоматизация тестирования веб-приложений, разработка автотестов, интеграция с CI/CD, E2E тестирование',
        category: 'Тестирование',
        questionCount: 134,
        interviewCount: 22,
        lastUpdated: '3 дня назад',
        href: '/questions/qa-automation',
        imagePath: '/specializations/playwright-architecture.png',
        techIcons: [
          { component: SiSelenium, name: 'Selenium', color: '#43B02A' },
          { component: SiCypress, name: 'Cypress', color: '#17202C' },
          { component: SiJenkins, name: 'Jenkins' },
        ],
        enabled: false,
      },
    ],
  },
  {
    id: 'analytics',
    title: 'Аналитика и Data Science',
    description: 'Работа с данными и бизнес-процессами: машинное обучение, статистический анализ, продуктовая и бизнес-аналитика',
    enabled: true,
    specializations: [
      {
        id: 'data-scientist',
        title: 'Data Scientist',
        description: 'Построение ML моделей, статистический анализ данных, feature engineering, проведение экспериментов',
        category: 'Аналитика и Data Science',
        questionCount: 156,
        interviewCount: 21,
        lastUpdated: '4 дня назад',
        href: '/questions/data-scientist',
        imagePath: '/specializations/a-screen-shot-of-a-computer.jpg',
        techIcons: [
          { component: SiPython, name: 'Python' },
          { component: SiJupyter, name: 'Jupyter' },
          { component: SiTensorflow, name: 'TensorFlow' },
        ],
        enabled: true,
      },
      {
        id: 'system-analyst',
        title: 'System Analyst',
        description: 'Анализ бизнес-требований, проектирование IT-систем, моделирование процессов, техническая документация',
        category: 'Аналитика и Data Science',
        questionCount: 78,
        interviewCount: 12,
        lastUpdated: '1 неделя назад',
        href: '/questions/system-analyst',
        imagePath: '/specializations/close-up-photo-of-survey-spreadsheet.jpg',
        techIcons: [
          { component: SiMiro, name: 'Miro' },
          { component: SiConfluence, name: 'Confluence' },
          { component: SiJira, name: 'Jira' },
        ],
        enabled: true,
      },
      {
        id: 'data-analyst',
        title: 'Data Analyst',
        description: 'Сбор и анализ данных, построение дашбордов и отчетов, работа с SQL, визуализация инсайтов',
        category: 'Аналитика и Data Science',
        questionCount: 112,
        interviewCount: 17,
        lastUpdated: '5 дней назад',
        href: '/questions/data-analyst',
        imagePath: '/specializations/monitor-screengrab.jpg',
        techIcons: [
          { component: SiPython, name: 'Python' },
          { component: SiPostgresql, name: 'SQL' },
          { component: SiJupyter, name: 'Jupyter' },
        ],
        enabled: true,
      },
      {
        id: 'business-analyst',
        title: 'Business Analyst',
        description: 'Анализ бизнес-процессов, сбор и документирование требований, работа со стейкхолдерами в Agile',
        category: 'Аналитика и Data Science',
        questionCount: 95,
        interviewCount: 14,
        lastUpdated: '6 дней назад',
        href: '/questions/business-analyst',
        imagePath: '/specializations/person-using-macbook-pro.jpg',
        techIcons: [
          { component: SiJira, name: 'Jira' },
          { component: SiConfluence, name: 'Confluence' },
          { component: SiMiro, name: 'Miro' },
        ],
        enabled: true,
      },
      {
        id: 'product-analyst',
        title: 'Product Analyst',
        description: 'Анализ продуктовых метрик и пользовательского поведения, A/B тестирование, исследование UX',
        category: 'Аналитика и Data Science',
        questionCount: 87,
        interviewCount: 13,
        lastUpdated: '1 неделя назад',
        href: '/questions/product-analyst',
        imagePath: '/specializations/a-b-testing-tiles.png',
        techIcons: [
          { component: SiGoogleanalytics, name: 'Google Analytics' },
          { component: SiPython, name: 'Python' },
          { component: SiPostgresql, name: 'SQL' },
        ],
        enabled: true,
      },
    ],
  },
  {
    id: 'management',
    title: 'Управление',
    description: 'Управление IT-проектами и продуктами: планирование, координация команды, стратегия развития, Agile/Scrum',
    enabled: true,
    specializations: [
      {
        id: 'it-project-manager',
        title: 'IT Project Manager',
        description: 'Управление IT-проектами, планирование спринтов, работа в Agile/Scrum, координация команды разработки',
        category: 'Управление',
        questionCount: 123,
        interviewCount: 18,
        lastUpdated: '3 дня назад',
        href: '/questions/it-project-manager',
        imagePath: '/specializations/printed-sticky-notes-glued-on-board.jpg',
        techIcons: [
          { component: SiJira, name: 'Jira' },
          { component: SiNotion, name: 'Notion' },
          { component: SiMiro, name: 'Miro' },
          { component: SiConfluence, name: 'Confluence' },
        ],
        enabled: false,
      },
      {
        id: 'it-product-manager',
        title: 'IT Product Manager',
        description: 'Разработка продуктовой стратегии и roadmap, определение метрик успеха, работа с пользователями',
        category: 'Управление',
        questionCount: 145,
        interviewCount: 20,
        lastUpdated: '2 дня назад',
        href: '/questions/it-product-manager',
        imagePath: '/specializations/person-writing-on-white-board.jpg',
        techIcons: [
          { component: SiProducthunt, name: 'Product Hunt' },
          { component: SiFigma, name: 'Figma' },
          { component: SiNotion, name: 'Notion' },
          { component: SiJira, name: 'Jira' },
        ],
        enabled: false,
      },
    ],
  },
]
